// extracted by mini-css-extract-plugin
export default {"container":"CompanyList_container__HmUUx","switch":"CompanyList_switch__lTiAr font-sm-regular","panelContainer":"CompanyList_panelContainer__y38VZ"};